// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"fe83c365","78":"6c08004c","98":"bab01d9c","255":"9f3c2ac7","300":"4f4e7d1a","307":"f8a92b21","333":"11a55b70","496":"248484da","593":"bc99a1cc","950":"bbe7eeb5"}[chunkId] + ".chunk.js";
};